// Borradores de formulario en localStorage.
//
// Existen porque CLAUDE.md lo exige: en conexion intermitente, un corte no
// puede hacerle perder al usuario lo que ya escribio.
//
// Pero traen un riesgo que costo detectar: al volver dias despues, el
// formulario aparece pre-rellenado con datos de otra sesion y no hay nada en
// pantalla que lo explique. Alguien con prisa puede publicar informacion que no
// escribio. Por eso ahora un borrador (a) caduca, y (b) se anuncia.

const VIGENCIA_MS = 24 * 60 * 60 * 1000;

export function leerBorrador(claveActual, clavesAnteriores = []) {
  clavesAnteriores.forEach((clave) => window.localStorage.removeItem(clave));

  const crudo = window.localStorage.getItem(claveActual);
  if (!crudo) return null;

  try {
    const sobre = JSON.parse(crudo);
    // Formato viejo (sin sobre): se descarta. No se puede saber su edad, y un
    // borrador de origen desconocido es justo lo que se quiere evitar.
    if (!sobre || typeof sobre !== "object" || !sobre.guardadoEn) {
      window.localStorage.removeItem(claveActual);
      return null;
    }
    if (Date.now() - sobre.guardadoEn > VIGENCIA_MS) {
      window.localStorage.removeItem(claveActual);
      return null;
    }
    return JSON.stringify(sobre.datos);
  } catch {
    window.localStorage.removeItem(claveActual);
    return null;
  }
}

/// ¿Hay un borrador vigente? Usa leerBorrador para aplicar la misma caducidad,
/// asi no puede decir "si" sobre uno que leerBorrador va a descartar.
export function hayBorrador(clave) {
  return leerBorrador(clave) !== null;
}

export function guardarBorrador(clave, datos) {
  window.localStorage.setItem(
    clave,
    JSON.stringify({ guardadoEn: Date.now(), datos }),
  );
}

export function limpiarBorrador(clave, clavesAnteriores = []) {
  window.localStorage.removeItem(clave);
  clavesAnteriores.forEach((anterior) => window.localStorage.removeItem(anterior));
}
